_collow.components.QuizMultiAnswer = class QuizMultiAnswer extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  questionElements;
  answer = [];
  studentAnswer = [];

  constructor(root, elements, params) {
    super();
    this.root = root;
    this.elements = elements;
    this.params = params;

    this.questionElements = Array.from(root.childNodes)
      .filter(node => 
        node.nodeType === Node.ELEMENT_NODE && 
        typeof node.hasAttribute === 'function' &&
        node.hasAttribute("data-question")
      );
    this.questionElements.forEach(
      (el, index) => (el.dataset.quizIndex = index)
    );
    this.getAnswers();
    this.questionElements.forEach((el) =>
      this.listen(el, "click", this.changeSelected)
    );
    this.listen(document.body, "_collow.quiz-finished", this.showResults);
  }

  //TODO change this to checkbox functionality
  changeSelected = ({ target }) => {
    const element = target.closest(".question-option");
    const state = element.dataset.quizItemSelected == "false" ? false : true;
    element.dataset.quizItemSelected = `${!state}`;
    element.querySelector("input").checked = !state;
    const answerIndex = element.dataset.quizIndex;

    if (state)
      this.studentAnswer = this.studentAnswer.filter(
        (_, ind) => ind != this.studentAnswer.indexOf(+answerIndex)
      );
    if (!state) this.studentAnswer.push(+answerIndex);
    this.sendAnswer();
  };

  sendAnswer = () => {
    let points = 0;
    // see if the answer length is correct or by default 0 points
    if (this.answer.length == this.studentAnswer.length) {
      this.correctAnswer = true;
      //   check if all the student answers are included in answers
      this.studentAnswer.forEach((res) => {
        const answerIncluded = this.answer.includes(res);
        if (!answerIncluded) this.correctAnswer = false;
      });
      if (this.correctAnswer) points = this.params.points;
    }

    this.dispatch(this.root, "_collow.quiz-points", {
      points,
      index: this.params.index,
    });
  };

  getAnswers = () => {
    this.questionElements.forEach((el, ind) => {
      if (el.dataset.quizAnswer == "true") this.answer.push(ind);
    });

    this.questionElements.forEach((el) =>
      el.removeAttribute("data-quiz-answer")
    );
  };

  showResults = () => {
    this.dispatch(
      this.root,
      "_collow.quiz-finished",
      { correct: this.correctAnswer },
      false
    );

    this.dispatch(
      this.root,
      `_collow.hint-${this.params.index}`,
      this.correctAnswer
    );

    this.questionElements.forEach((el) =>
      this.unlisten(el, "click", this.changeSelected)
    );
    this.answer.forEach(
      (answer) =>
        (this.questionElements[answer].dataset.quizCorrectAnswer = true)
    );

    if (this.studentAnswer != this.answer && this.studentAnswer)
      this.studentAnswer.forEach((studAnswer) => {
        if (!this.answer.includes(studAnswer))
          this.questionElements[studAnswer].dataset.quizCorrectAnswer = false;
      });
  };
};
